import Vuex from 'vuex'
import Vue from 'vue'
import largeSidebar from './modules/largeSidebar'
import compactSidebar from './modules/compactSidebar'
import themeConfig from './modules/themeConfig'
import verticalSidebar from './modules/verticalSidebar'
import clients from './modules/admnistration/clients'
import invoice from './modules/invoices/invoice'
import mandatoryTip from './modules/invoices/mandatoryTip'
import printDataShop from './modules/invoices/printDataShop'
import changeDateDocuments from './modules/invoices/changeDateDocuments'
import authentication from './modules/sessions/authentication'
import statistics from './modules/dashboard/statistics'
import users from './modules/admnistration/users'
import firmas from './modules/admnistration/firmas'
import credentialsTef from "./modules/admnistration/credentialsTef";
import historyTef from "./modules/admnistration/historyTef";
import parametros from "./modules/admnistration/parametros";
import ats from "./modules/invoices/ats";
import wideEvents from "./modules/wideEvents/wideEvents";

// Load Vuex
Vue.use(Vuex)

// Create store
export default new Vuex.Store({
  modules: {
    largeSidebar,
    compactSidebar,
    themeConfig,
    invoice,
    mandatoryTip,
    printDataShop,
    changeDateDocuments,
    verticalSidebar,
    clients,
    authentication,
    statistics,
    users,
    firmas,
    credentialsTef,
    historyTef,
    parametros,
    ats,
    wideEvents,
  },
})
